var exports = {};

var builder = require("./lib/builder.js");
exports.buildTrees = builder.buildTrees;

module.exports = exports;
